import type { CommunitySwitcher } from "../types/CommunitySwitcher";
import { cn } from "../helpers/cn";
import { Typography } from "@circleco/compass/components/Typography";
import { CommunitySwitcherAvatar } from "./CommunitySwitcherAvatar";
import { CommunityNotificationsBadge } from "@circleco/community-switcher/components/CommunityNotificationsBadge";
import { SWITCHER_ICON_CLASS } from "./constants";

export interface CommunitiesModalLinkIconAndNameProps {
  readonly community: CommunitySwitcher;
  readonly iconUrl: string;
  readonly notificationCount: number;
}

export const CommunitiesModalLinkIconAndName = ({
  community,
  iconUrl,
  notificationCount,
}: CommunitiesModalLinkIconAndNameProps) => (
  <>
    <div
      className={cn(SWITCHER_ICON_CLASS, {
        "active border-primary switcher__active_community":
          community.is_current_community,
      })}
    >
      <span className="relative inline-flex">
        <CommunitySwitcherAvatar iconUrl={iconUrl} name={community.name} />
        <CommunityNotificationsBadge notificationCount={notificationCount} />
      </span>
    </div>
    <Typography color="primary" variant="label-md">
      {community.name}
    </Typography>
  </>
);
